import { render, staticRenderFns } from "./CustomFieldsForm.vue?vue&type=template&id=6f84b539&scoped=true&"
import script from "./CustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsForm.vue?vue&type=style&index=0&id=6f84b539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84b539",
  null
  
)

export default component.exports